import React from 'react';

import { ListWithTitle } from '../components/ListWithTitle';
import { Paragraph } from '../components/Paragraph';
import { Title } from '../components/Title';
import { AccessToOrRequestForCorrectionOfData } from './AccessToOrRequestForCorrectionOfData';
import { ChangesInThisPrivacyStatement } from './ChangesInThisPrivacyStatement';
import { CollectionOfPersonalData } from './CollectionOfPersonalData';
import { CookiesAndLogFiles } from './CookiesAndLogFiles';
import { DisclosureOrTransferOfData } from './DisclosureOrTransferOfData';
import { Enquiries } from './Enquiries';
import { GlintsAdvertisersAndOnlineApplications } from './GlintsAdvertisersAndOnlineApplications';
import { GlintsProfile } from './GlintsProfile';
import { LinksToOtherWebsites } from './LinksToOtherWebsites';
import { PurposeOfCollectionAndUseOfPersonalData } from './PurposeOfCollectionAndUseOfPersonalData';
import { RetentionOfPersonalData } from './RetentionOfPersonalData';
import { Security } from './Security';
import { StoringYourResume } from './StoringYourResume';
import { SubscriptionOfMaterials } from './SubscriptionOfMaterials';
import { Testimonials } from './Testimonials';

export const PrivacyPolicy = () => {
  return (
    <>
      <Title>Privacy Policy</Title>
      <Paragraph>
        Glints respects the privacy of the personal information and your data
        and will ensure compliance by its staff to the strictest standards of
        security and confidentiality in respect of all personal information and
        data submitted by you via the Site and Glints will not, subject to the
        terms herein, release such information to anyone without your prior
        consent (whether registered or not).
      </Paragraph>
      <Paragraph>
        You are strongly recommended to read this privacy statement (“Privacy
        Statement”) carefully to have an understanding of Glints policy and
        practices with regard to the treatment of personal information and data
        provided by Users on the Site. This Privacy Statement is applicable to
        both registered and unregistered Users, and the terms herein may be
        updated, revised, varied and/or amended from time to time as Glints may
        deem necessary and/or appropriate.
      </Paragraph>
      <ListWithTitle
        title={
          <>
            By registering for or using the services/Site, or by clicking the
            ‘Sign up’ button, you:
          </>
        }
        list={[
          <>
            Consent to Glints and/or Glints’ group companies collecting, using,
            disclosing and/or processing your personal data for the purposes as
            described below;
          </>,
          <>
            Consent to Glints and/or Glints group companies disclosing your
            personal data to Glints and/or Glints’ group companies’ third party
            service providers or agents (whether within or outside Singapore)
            for the purposes as described below.
          </>,
        ]}
      />
      <Paragraph>
        If you have questions or concerns regarding this Privacy Statement,
        please contact the Data Protection Officer, whose contact details are
        set out under the section headed “Enquiries” below.
      </Paragraph>
      <Paragraph>
        In this Privacy Statement, the following terms shall have the respective
        meanings specified below unless the context otherwise requires:
      </Paragraph>
      <Paragraph>
        <b>“Advertiser(s)”</b> means a User or Company who places a job
        advertisement or promotes any job related activities via the Site.
      </Paragraph>
      <Paragraph>
        <b>“Glints”</b> means Glints Pte Ltd.
      </Paragraph>
      <Paragraph>
        <b>“Glints Group”</b> means Glints Pte Ltd, Glints Singapore Pte Ltd, PT
        Glints Indonesia Group, PT Intra Global Talenta, Glints Sdn Bhd and any
        other subsidiaries of Glints Pte Ltd.
      </Paragraph>
      <Paragraph>
        <b>“Job Seeker(s)”</b> means users seeking employment.
      </Paragraph>
      <Paragraph>
        <b>“Sign up User(s)”</b> means Users who sign up on the Site to obtain
        services offered by Glints. Unless the context provides otherwise,
        references in this Privacy Statement to “users” or “you” include
        references to generic users and Registered Users.
      </Paragraph>
      <Paragraph>
        <b>“Site”</b> means any website, job portal or mobile application owned
        and operated by Glints and its affiliates/subsidiaries or its service
        providers.
      </Paragraph>
      <PurposeOfCollectionAndUseOfPersonalData />
      <CollectionOfPersonalData />
      <DisclosureOrTransferOfData />
      <GlintsAdvertisersAndOnlineApplications />
      <GlintsProfile />
      <StoringYourResume />
      <SubscriptionOfMaterials />
      <AccessToOrRequestForCorrectionOfData />
      <CookiesAndLogFiles />
      <LinksToOtherWebsites />
      <Testimonials />
      <Security />
      <RetentionOfPersonalData />
      <ChangesInThisPrivacyStatement />
      <Enquiries />
    </>
  );
};
